import { render, staticRenderFns } from "./MobileDataList.vue?vue&type=template&id=03b16f72&scoped=true"
import script from "./MobileDataList.vue?vue&type=script&lang=js"
export * from "./MobileDataList.vue?vue&type=script&lang=js"
import style0 from "./MobileDataList.vue?vue&type=style&index=0&id=03b16f72&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03b16f72",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataIterator } from 'vuetify/lib/components/VDataIterator';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSimpleCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VBtn,VDataIterator,VIcon,VSelect,VSimpleCheckbox})
